import React, { RefObject } from "react"

import { Slot } from "@/components/Slot"
import { cn } from "@/utils/tailwind"

type HeadingSize = 1 | 2 | 3 | 4 | 5 | 6

function getHeadingType(heading: HeadingSize) {
  switch (heading) {
    case 1: {
      return "h1"
    }
    case 2: {
      return "h2"
    }
    case 3: {
      return "h3"
    }
    case 4: {
      return "h4"
    }
    case 5: {
      return "h5"
    }
    case 6: {
      return "h6"
    }
  }
}

const sizes = {
  1: "text-4xl",
  2: "text-2xl",
  3: "text-xl",
  4: "text-lg",
  5: "text-base",
  6: "text-sm",
}

interface Props extends React.HTMLAttributes<HTMLHeadingElement> {
  size?: HeadingSize
  asChild?: boolean
  order?: HeadingSize
  ref?: RefObject<HTMLHeadingElement>
}

export function Heading({ className, size, order, asChild = false, children, ref, ...props }: Props) {
  const Comp = asChild ? Slot : getHeadingType(order ?? size ?? 1)
  return (
    <Comp className={cn("font-semibold text-slate-700", sizes[size ?? order ?? 1], className)} ref={ref} {...props}>
      {children}
    </Comp>
  )
}
